<template>
  <NuxtLink
    :to="url"
    class="border-2 rounded-large border-primary-100 p-10 flex flex-col group/button h-full"
  >
    <div class="mb-15 bg-gray-50">
      <FieldItemTypeImage
        v-if="image"
        v-bind="image"
        :config="imageStyle"
        img-class="w-full"
        class="rounded"
      />
    </div>

    <h3
      class="text-xl font-bold pb-10 text-blue-900 group-hover:text-blue-500 transition px-8 hyphens-auto"
    >
      {{ title }}
    </h3>

    <p
      v-if="organisationLabel"
      class="text-base font-bold pb-20 text-primary-600 transition px-8 grow"
    >
      {{ organisationLabel }}
    </p>
    <div>
      <div class="button is-link">
        {{ $texts('details', 'Details') }}
        <span class="sr-only">{{
          $texts('accessibility.forThisPublication', 'zu dieser Publikation')
        }}</span>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type {
  CommerceProductPublicationTeaserFragment,
  ImageItemFragment,
} from '#graphql-operations'

const props = defineProps<{
  url: string
  title: string
  organisationLabel?: string
  // We support two different types, so it can be used from a GraphQL fragment or from an Elasticsearch hit.
  teaserImage?:
    | CommerceProductPublicationTeaserFragment['teaserImage']
    | ImageItemFragment
}>()

const { $texts } = useNuxtApp()

const image = computed<ImageItemFragment | undefined>(() => {
  if (!props.teaserImage) {
    return
  }

  if ('copyright' in props.teaserImage) {
    return props.teaserImage.image
  } else if ('file' in props.teaserImage) {
    return props.teaserImage
  }

  return undefined
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 3 / 2,
  sizes: {
    sm: 322,
    md: 328,
    lg: 362,
    xl: 307,
  },
})
</script>
